<template>
  <div>
    <v-tabs v-model="tabs.main">
      <v-tab>Parseur</v-tab>
      <v-tab>Navigateur</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabs.main" class="mt-2">
      <v-tab-item>
        <v-jsoneditor
          v-if="parserField"
          v-model="parserField"
          :plus="false"
          height="650px"
          :options="{ mode: 'code' }">
        </v-jsoneditor>
      </v-tab-item>
      <v-tab-item>
        <v-jsoneditor
          v-if="browserField"
          v-model="browserField"
          :plus="false"
          height="650px"
          :options="{ mode: 'code' }">
        </v-jsoneditor>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
export default {
  name: 'CrawlerConfigForm',
  props: ['browser', 'parser'],
  components: {
    VJsoneditor: () => import('v-jsoneditor/src/index')
  },
  computed: {
    browserField: {
      get () {
        return this.browser
      },
      set (val) {
        this.$emit('update:browser', val)
      }
    },
    parserField: {
      get () {
        return this.parser
      },
      set (val) {
        this.$emit('update:parser', val)
      }
    }
  },
  data () {
    return {
      tabs: {
        main: 0
      }
    }
  },
}
</script>

<style scoped>

</style>